import { ColumnHelper, HeaderContext } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";
import { Localisation, LocalisationKeys } from "PFTypes";
import { useCallback } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

import { LocalisationKeysForm } from "../localisation_keys_form";
import { countMissingStrings } from "./count_missing_strings";
import { TranslationsCounterLabel } from "./translations_counter_label";

export const useColumnsGenerator = (accountId: number, localisationKey: LocalisationKeys) => {
  const { t } = useTranslation("admin", { keyPrefix: "localisation.table.headers" });

  const header = useCallback(
    (header: HeaderContext<Localisation, unknown>) => (
      <Typography variant="bodyRegular" tag="span">
        {t(`${header.header.id}` as unknown as TemplateStringsArray)}
      </Typography>
    ),
    [t]
  );

  return useCallback(
    (columnHelper: ColumnHelper<Localisation>) => [
      columnHelper.accessor((row) => row.name, {
        id: "name",
        size: 200,
        header,
        cell: (info) => info.getValue(),
        enableSorting: false
      }),
      columnHelper.accessor((row) => row.localisation, {
        id: "strings",
        header: "",
        cell: (info) =>
          info.getValue() && <TranslationsCounterLabel {...countMissingStrings(info.getValue())} />,
        enableSorting: false
      }),
      columnHelper.accessor((row) => row, {
        id: "actions",
        header,
        size: 100,
        cell: (info) =>
          info.getValue() && (
            <LocalisationKeysForm
              accountId={accountId}
              localisationKey={localisationKey}
              localisation={info.getValue()}
            />
          ),
        enableSorting: false
      })
    ],
    [header, accountId, localisationKey]
  );
};
